<template>
    <!-- 短信订阅退订 -->
    <div id="dxdy">
        <div style="padding: 20px;text-align: center;">
          <van-image
          width="100"
          :src="require('@/page/dxdy/logo.png')"
        />
        </div>
        <div v-if="isSubmit" style="margin-top: 25%; text-align: center;line-height: 30px;">
            <h1>{{ splitUrlParam && splitUrlParam.status === '0' ? '确认退订消息？' : '确定重新订阅消息？' }}</h1>
            <div style="color: red;">{{ splitUrlParam && splitUrlParam.status === '0' ? '退订后，您将不会收到该类别消息！' : '订阅后，您可继续收到该类别消息！' }}</div>
            <div style="margin-top: 20px;"><van-button :loading="loading" type="info" loading-text="提交中..." @click="submitHandle" style="width: 150px;" :disabled="loading">{{ splitUrlParam && splitUrlParam.status === '0' ? '确定退订' : '确定订阅' }}</van-button>
            </div>
        </div>
        <div v-if="!isSubmit" style="margin-top: 10%; text-align: center;line-height: 30px;">
            <div v-if="isSuccess">
                <h1>消息{{ splitUrlParam && splitUrlParam.status === '0' ? '退订成功' : '订阅成功'}}<van-icon name="passed" size="28" style="margin-left: 5px; vertical-align: -2px;" color="#28d328" /></h1>
                <div>{{ splitUrlParam && splitUrlParam.status === '0' ? '稍后您会收到退订成功短信' : '稍后您会收到订阅成功短信'}}</div>
                <div>请注意查收！</div>
            </div>
            <div v-else>
                <h1>消息{{ splitUrlParam && splitUrlParam.status === '0' ? '退订失败' : '订阅失败'}}</h1>
                <div v-if="errorMessage" style="color: red;">{{ errorMessage }}</div>
                <div>建议您稍后重试或者联系客服</div>
                <div>4008-889-889</div>
            </div>
        </div>
    </div>
  </template>

  <script>
      /* eslint-disable */
    import SERVICEPUBLICMSGAPI from '@/common/ajax/API/SERVICEPUBLICMSGAPI'
    import { Toast } from 'vant'

    export default {
      name: 'cjwt',
      data () {
        return {
            splitUrlParam: {},
            isSubmit: true,
            isSuccess: false,
            loading: false,
            errorMessage: ''
        }
      },
      created(){
        this.errorMessage = ''
        this.splitUrlParam = this.utils.splitUrlParam()
      },
      methods: {
        async submitHandle() {
            this.loading = true
            if(this.splitUrlParam.isvalid == '0') {
              this.loading = false
              this.isSuccess = false
              this.isSubmit = false
              this.errorMessage = '链接已失效，请点击最新短信链接！'
              return
            }
            const res = await SERVICEPUBLICMSGAPI.msgTYPE(this.splitUrlParam)
            this.loading = false
            if(res.resultStatus == '0') {
              // 成功
              this.isSuccess = true
              this.isSubmit = false
            } else {
              this.isSuccess = false
              this.isSubmit = false
            }
            if(['-41', '-44', '-45'].includes(res.resultStatus)) {
              this.errorMessage = res.resultMessage
            }
        }
      }
    }
  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="stylus" rel="stylesheet/stylus">
  </style>



// WEBPACK FOOTER //
// dxdy.vue?9dc23580